import { DocumentContentType } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
/**
 * FILE documents require fileId/fileName/fileType; URL documents require a url.
 * Mirrors the legacy `@ValidateIf(o => o.contentType === FILE | URL)` via superRefine;
 * the fields stay optional on the type and conditional at runtime.
 */
export const createAgencyDocumentSchema = z
    .object({
    fileId: z.string().min(1).optional(),
    fileName: z.string().min(1).optional(),
    contentType: z.nativeEnum(DocumentContentType),
    description: z.string().optional(),
    fileType: z.string().min(1).optional(),
    tags: z.array(z.string()).optional(),
    title: z.string().min(1),
    url: z.string().url().optional(),
})
    .superRefine((data, ctx) => {
    if (data.contentType === DocumentContentType.FILE) {
        for (const field of ['fileId', 'fileName', 'fileType']) {
            if (!data[field]) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `${field} is required for FILE documents`,
                    path: [field],
                });
            }
        }
    }
    if (data.contentType === DocumentContentType.URL && !data.url) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'url is required for URL documents',
            path: ['url'],
        });
    }
});
export const updateAgencyDocumentSchema = z.object({
    fileId: z.string().min(1).optional(),
    fileName: z.string().min(1).optional(),
    contentType: z.nativeEnum(DocumentContentType).optional(),
    description: z.string().optional(),
    fileType: z.string().min(1).optional(),
    tags: z.array(z.string()).optional(),
    title: z.string().min(1).optional(),
    url: z.string().url().optional(),
});
// Query param: a single `?tags=x` arrives as a string, absent as []. Matches the
// legacy `@Transform(v => Array.isArray(v) ? v : typeof v === 'string' ? [v] : [])`.
export const filterAgencyDocumentSchema = z.object({
    tags: z.preprocess((value) => {
        if (Array.isArray(value))
            return value;
        const single = z.string().safeParse(value);
        return single.success ? [single.data] : [];
    }, z.array(z.string()).optional()),
});
